export default __webpack_public_path__ + "static/media/bg9.4b4580a0.jpeg";